import 'react';
import ButtonLoader from './style.js';
import { jsx } from '@emotion/react';

var Loader = _ref => {
  var {
    buttonColor,
    buttonType,
    className = '',
    disabled,
    isFullWidth = false,
    isLoading,
    textColor
  } = _ref;
  return jsx(ButtonLoader, {
    buttonColor: buttonColor,
    buttonType: buttonType,
    className: className,
    disabled: disabled,
    isFullWidth: !!isFullWidth,
    isLoading: isLoading,
    textColor: textColor
  }, jsx("div", null, jsx("span", null), jsx("span", null), jsx("span", null)));
};

export { Loader as default };
